import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import { ReactComponent as Cross } from '@jetshop/ui/svg/Cross.svg';
import React from 'react';
import { styled } from 'linaria/react';

import { theme } from '../../Theme';
import { Above, Below } from '@jetshop/ui/Breakpoints';

export const FilterGroup = styled('div')`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.875rem;
`;
const Label = styled('label')`
  font-weight: 300;
  padding-right: 0.25rem;
  text-transform: capitalize;
  ${theme.below.md} {
    display: none;
  }
`;
const Value = styled('span')`
  font-weight: 600;
  padding-right: 1rem;

  ${theme.below.md} {
    font-size: 12px;
  }
`;
export const AppliedFilter = styled('button')`
  color: white;
  border: 0;
  padding: 0.5rem;
  display: inline-flex;
  color: ${theme.colors.black};
  height: 36px;
  align-items: center;
  svg path {
    fill: ${theme.colors.black};
  }
`;

export const FilterWrapper = styled('aside')`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.5rem;
  max-width: 90rem;
  padding: 0 2rem 2rem;
  margin: auto;
  width: 100%;
  gap: 0.5rem;
  ${theme.below.md} {
    flex-direction: row;
    justify-content: center;

  }
`;

export const ClearButton = styled('button')`
  background: none;
  text-decoration: underline;
  width: 160px;
  height: 36px;
  border: 1px solid ${theme.colors.black};
  color: ${theme.colors.black};
  text-decoration: none;
  :hover,
  :focus {
    opacity: 0.8;
    outline: none;
  }
`;

export function ActiveFilters({ filters }) {
  const { clearAllFilters } = useFilters();

  if (!filters) return null;

  const activeListFilters = filters.filter(listFilter => {
    return listFilter.hasActiveItems;
  });

  if (activeListFilters.length === 0) return null;

  return (
    <FilterWrapper className='filter-wrapper'>
      {activeListFilters.map(listFilter => {
        return (
          <FilterGroup key={listFilter.id}>
            {listFilter.items
              .filter(item => item.isActive)
              .map(listFilterItem => (
                <ActiveListFilterItem
                  item={listFilterItem}
                  listFilter={listFilter}
                  key={listFilterItem.value}
                />
              ))}
          </FilterGroup>
        );
      })}
      <ClearButton type="button" onClick={clearAllFilters}>
        {t('Clear all filters')}
      </ClearButton>
    </FilterWrapper>
  );
}

function ActiveListFilterItem({ item, listFilter }) {
  const { apply } = useListFilter({ filter: listFilter });
  return (
    <AppliedFilter
      type="button"
      key={item.value}
      onClick={() => {
        apply({ value: item.value });
      }}
    >
      <Label>{listFilter.name} </Label>
      <Value>{item.text}</Value>
      <Cross />
    </AppliedFilter>
  );
}
